import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import "@/App.css";
import { AuthProvider } from "@/context/AuthContext";
import LandingPage from "@/pages/LandingPage";
import HomePage from "@/pages/HomePage";
import DiwaliCollectionPage from "@/pages/DiwaliCollectionPage";
import ProductPage from "@/pages/ProductPage";
import OurStoryPage from "@/pages/OurStoryPage";
import PartnerBenefitsPage from "@/pages/PartnerBenefitsPage";
import TermsOfServicePage from "@/pages/TermsOfServicePage";
import ReturnRefundPolicyPage from "@/pages/ReturnRefundPolicyPage";
import PrivacyPolicyPage from "@/pages/PrivacyPolicyPage";
import ResourcesPage from "@/pages/ResourcesPage";
import ArticlePage from "@/pages/ArticlePage";
import LandingSeoPage from "@/pages/LandingSeoPage";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import AdminCollectionsPage from "@/pages/AdminCollectionsPage";
import AdminProductsPage from "@/pages/AdminProductsPage";
import AdminArticlesPage from "@/pages/AdminArticlesPage";
import AdminLandingPagesPage from "@/pages/AdminLandingPagesPage";
import AdminSiteContentPage from "@/pages/AdminSiteContentPage";
import AdminGreenGiftProjectsPage from "@/pages/AdminGreenGiftProjectsPage";
import AdminPartnerBrandsPage from "@/pages/AdminPartnerBrandsPage";
import AuthCallback from "@/pages/AuthCallback";
import NotFoundPage from "@/pages/NotFoundPage";
import ThankYouPage from "@/pages/ThankYouPage";
import DiwaliCataloguePage from "@/pages/DiwaliCataloguePage";
import GlobalEnquiryPopup from "@/components/landing/GlobalEnquiryPopup";

/**
 * Detect Emergent Google Auth callback (`#session_id=...`) synchronously
 * during render — MUST run before the router matches other routes.
 */
function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/give-back" element={<LandingPage />} />
        <Route path="/collections" element={<DiwaliCollectionPage />} />
        <Route path="/diwali-collection" element={<DiwaliCollectionPage />} />
        <Route path="/diwali-collection/:slug" element={<ProductPage />} />
        <Route path="/our-story" element={<OurStoryPage />} />
        <Route path="/partner-benefits" element={<PartnerBenefitsPage />} />
        <Route path="/terms-of-service" element={<TermsOfServicePage />} />
        <Route path="/return-refund-policy" element={<ReturnRefundPolicyPage />} />
        <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
        <Route path="/resources" element={<ResourcesPage />} />
        <Route path="/resources/:slug" element={<ArticlePage />} />
        <Route path="/collections/:slug" element={<LandingSeoPage />} />
        <Route path="/thank-you" element={<ThankYouPage />} />
        <Route path="/diwali-catalogue" element={<DiwaliCataloguePage />} />
        <Route path="/admin" element={<AdminLogin />} />
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/admin/leads" element={<AdminDashboard />} />
        <Route path="/admin/collections" element={<AdminCollectionsPage />} />
        <Route path="/admin/products" element={<AdminProductsPage />} />
        <Route path="/admin/articles" element={<AdminArticlesPage />} />
        <Route path="/admin/landing-pages" element={<AdminLandingPagesPage />} />
        <Route path="/admin/site-content" element={<AdminSiteContentPage />} />
        <Route path="/admin/green-gift-projects" element={<AdminGreenGiftProjectsPage />} />
        <Route path="/admin/partner-brands" element={<AdminPartnerBrandsPage />} />
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
      <GlobalEnquiryPopup />
    </>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppRouter />
      </AuthProvider>
    </BrowserRouter>
  );
}
